export const name = 'AcceptAccountController';

export default function AcceptAccountController(
  $gzEULA,
  rnInvitation,
  rnAuthService,
  rnSession,
  rnLocale,
  rnPreferences,
  $analytics,
  $state,
  $stateParams,
  $q,
  $translate,
  $location,
  $window
) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  const EVENT_NAME='accept invitation';
  const EVENT_CATEGORY='account';

  let analyticsEvent;
  let myParams = {};
  let locales;
  let user;
  let invitationId;

  let vm = this;
  vm.loading = true;
  vm.submitting = false;
  vm.accept = {};
  vm.form = {};

  // controller functions
  vm.submit = submit;
  vm.cancel = cancel;
  vm.go = go;
  vm.getName = getName;
  vm.invitationStatusPending = invitationStatusPending;
  vm.isValid = isValid;
  vm.existingUser = false;
  vm.openTerms = openTerms;
  vm.openPrivacyStatement = openPrivacyStatement;

  vm.unitTest = {
    getMyParams: function() {return myParams;},
    handleAcceptError: handleAcceptError,
  };

  activate();

  ////////////////////////
  function activate() {
    parseParams();

    vm.accept.hpidId = $stateParams.hpidId;

    let promises = [];
    promises.push(getInvitation(invitationId));
    promises.push(getLocales());
    promises.push(getCurrentEulaVersion());
    promises.push(getCurrentPrivacyVersion());
    return $q.all(promises).then(() => {
      let locale = _.find(locales, {value: vm.invitation.languageCode});
      if (locale) {
        rnLocale.setLocalePreference(locale);
        $translate.use(locale.value);
      }

      if (vm.invitation.status !== 'Pending') {
        vm.invalid = true;
        vm.invalidKey = 'register.register.Invitation_Error_' + vm.invitation.status;
        vm.invalidActionKey = 'register.register.AcceptUser_Error_Action_General';
        return;
      }

      let postAuthentication = _.get(myParams, 'data.postAuthentication');
      if (rnAuthService.isAuthenticated() && postAuthentication) {
        vm.existingUser = true;
      } else {
        if (!vm.accept.hpidId) {
          // Userneeds to authenticate with HP ID first (creating an account if necessary)
          _.set(myParams, 'invitationId', invitationId);
          _.set(myParams, 'state', 'acceptAccount');
          _.set(myParams, 'signout', true);
          $state.go('acceptHpIdSignIn', myParams);
        }
      }
    })
      .catch(error => {
        // No op
      })
      .finally(() => {
        vm.loading = false;
      });
  }

  function parseParams() {
    let urlParams = $location.search();

    myParams.data = $stateParams.data;

    if ($stateParams.bu) {
      myParams.bu = $stateParams.bu;
      vm.bu = $stateParams.bu;
    }

    invitationId = $stateParams.invitationId;
    if (!invitationId || invitationId === '') {
      invitationId = _.get(myParams, 'data.invitationId', undefined);
    }

    if (!invitationId) {
      $state.go('signin', {signout: true});
    }
  }

  function getInvitation(invitationId) {
    return rnInvitation.getById(invitationId).then(invitation => {
      vm.invitation = invitation;
      if (invitation.status !== 'Pending') {
        vm.invalid = true;
        vm.invalidKey = 'register.register.Invitation_Error_' + invitation.status;
        vm.invalidActionKey = 'register.register.AcceptUser_Error_Action_General';
      }
    })
      .catch((error) => {
        vm.invalid = true;
        vm.invalidActionKey = 'register.register.AcceptUser_Error_Action_General';

        let statusCode = _.get(error, 'smsError.statusCode');
        let subCode = _.get(error, 'smsError.subCode');

        switch (statusCode) {
          case 404:
            vm.invalidKey = 'register.register.Invitation_Error_Retrieve_NotFound';
            break;
          case 409:
            switch (subCode) {
              case 1100:
                vm.invalidKey = 'register.register.Invitation_Error_Multiple_Account_Association';
                break;
              default:
                vm.invalidKey = 'register.register.Invitation_Error_Multiple_Account_Association';
                break;
            }
            break;
          default:
            vm.invalidKey = 'register.register.Invitation_Error_Retrieve';
            break;
        }

        return $q.reject();
      });
  }

  function getLocales() {
    return rnLocale.allLocaleOptions().then(options => {
      locales = options;
    });
  }

  function getCurrentEulaVersion() {
    return $gzEULA.getCurrentVersion().then(version => {
      vm.accept.eulaVersion = version;
    });
  }

  function getCurrentPrivacyVersion() {
    return $gzEULA.getPrivacyVersion().then(version => {
      vm.accept.privacyVersion  = version;
    });
  }

  function submit() {
    if (!isValid()) { return; }

    if (vm.existingUser) {
      return acceptExisting();
    }
    else {
      return acceptNew();
    }
  }

  function acceptExisting() {
    let org = {
      name: vm.accept.organizationName,
      type: vm.invitation.organizationType,
      securityPassword: vm.accept.securityPassword
    };

    return rnInvitation.acceptInvitationWithExistingUser(`invitations/${vm.invitation.id}/org`, 'POST', org).then(data => {
      let orgId = data.organization.organizationId;
      return rnSession.switchContext({ id: orgId }).finally(() => {
        $analytics.eventTrack(EVENT_NAME, analyticsEvent);
        go();
      });
    })
      .catch(error => {
        handleAcceptError(error);
      }).finally(() => {
        vm.submitting = false;
      });

  }

  function acceptNew() {
    let url = vm.invitation._links.accept.href;
    vm.submitting = true;
    delete vm.errorKey;

    if (vm.accept.organizationName) {
      vm.accept.organizationName = vm.accept.organizationName.trim();
    }

    return rnInvitation.acceptInvitation(vm.accept, url).then((data) => {
      user = data.user;
      $analytics.setUsername(user.userId);
      $analytics.eventTrack(EVENT_NAME, analyticsEvent);
      go();
    })
      .catch((error) => {
        handleAcceptError(error);
      })
      .finally(() => {
        vm.submitting = false;
      });
  }

  function isValid() {
    if (vm.form.$invalid) { return false; }
    if (!vm.accept) { return false; }
    if (!vm.existingUser) {
      if (!vm.accept.acceptEula) { return false; }
      if (!vm.accept.acceptTerms) { return false; }
    }
    if (vm.submitting) { return false; }
    if (!vm.accept.organizationName) { return false; }
    if (vm.accept.organizationName.trim() === '') { return false; }

    return true;
  }

  function handleAcceptError(error) {
    let statusCode = _.get(error, 'smsError.statusCode', -1);
    let subCode = _.get(error, 'smsError.subCode', null);

    switch(statusCode) {
      case 401:
        if (subCode === 1019) {
          // Serial number is invalid
          vm.errorKey = 'register.register.Invitation_ErrorCode_Device_SN_Error';
        }
        else if (subCode === 1022) {
          // The serial number has an invalid format, which we will assume is because it needs to be uppercase
          vm.errorKey = 'devices.devices.Device_Serial_Number_Incorrect_Case';
        }
        else if (subCode === 1020) {
          // Issue validating the serial number (the service is probably down)
          vm.errorKey = 'register.register.Invitation_ErrorCode_Device_Validation_Internal_Error';
        }
        else {
          vm.errorKey = 'register.register.Error_Accepting_Invitation';
        }
        break;
      case 403:
        if (error.smsError.message === 'HPID migration in progress, this action is forbidden') {
          vm.errorKey = 'register.register.Invitation_Error_HPID_Migration';
        }
        else {
          vm.errorKey = 'register.register.Error_Accepting_Invitation';
        }
        break;
      case 404:
        // Invitation not found
        vm.errorKey = 'register.register.Invitation_ErrorCode_NotFound';
        break;
      case 409:
        if (subCode === 1002) {
          // A device with this serial number already exists for this model
          vm.errorKey = 'register.register.Invitation_ErrorCode_Device_SN_Exists';
        }
        else if (subCode === 1030) {
          vm.errorKey = 'register.register.EUID_Conflict';
        }
        else {
          // Username, email, or GBU Internal ID may already be in use
          vm.errorKey = 'register.register.Name_Conflict';
        }
        break;
      case 498:
        vm.errorKey = 'register.register.Invitation_ErrorCode_Expired';
        break;
      default:
        vm.errorKey = 'register.register.Error_Accepting_Invitation';
    }

    // $analytics.exceptionTrack() in the future
    $window.ga('send', 'exception', {
      exDescription: EVENT_NAME + " failed: " + _.get(error, 'smsError.message', 'unknown')
    });
  }

  function cancel() {
    $state.go('signin', {signout: true});
  }

  function go() {
    _.set(myParams, 'data.organizationName', vm.invitation.organizationName);
    myParams.forward = true;
    $state.go('signin', myParams);
  }

  function getName() {
    let name = '';
    if (_.get(user, 'firstName')) {
      name += user.firstName + ' ';
    }
    if (_.get(user, 'lastName')) {
      name += user.lastName;
    }
    return name.trim();
  }

  function invitationStatusPending() {
    if (vm.success) {
      return false;
    }
    return _.get(vm.invitation, 'status', '') === 'Pending';
  }

  function openTerms($event) {
    if ($event) {
      $event.stopPropagation();
    }
    $gzEULA.show();
  }

  function openPrivacyStatement($event){
    if ($event){
      $event.stopPropagation();
    }
    $window.open('http://www.hp.com/go/privacy', 'hp-privacy');
  }
}



// WEBPACK FOOTER //
// ./components/accept/account/accept-account.controller.js